<template>
  <BTr>
    <!-- Checkbox -->
    <b-td
      v-if="row.isFirstProduct"
      :rowspan="row.rowspan"
      class="!py-[12px] !pr-[4px]"
    >
      <b-checkbox
        v-if="row.status === 'Dibatalkan' || row.status === 'Dikirim'"
        class="[&_.custom-control-label::before]:!bg-[#E2E2E2] [&_.custom-control-label::after]:brightness-50"
        disabled
        indeterminate
      />
      <b-checkbox
        v-else
        v-model="selected"
        @change="emitToggleSelect"
      />
    </b-td>
    <!-- Product Name -->
    <b-td class="!py-[12px]">
      {{ row.productName }}
    </b-td>
    <!-- Product Variant -->
    <b-td
      v-if="!row.isBundling"
      class="!py-[12px]"
    >
      {{ row.variantName }}
    </b-td>
    <b-td
      v-else
      class="p-0"
    >
      <p
        v-for="(bundle, idx) in row.bundles"
        :key="bundle.id"
        class="border-b border-[#E0E0E0] mb-0 px-[28px] py-[12px]"
        :class="{ 'border-b-0': idx === row.bundles.length - 1 }"
      >
        {{ bundle.product_variant_name || '-' }}
      </p>
    </b-td>
    <!-- Total Item -->
    <b-td class="!py-[12px]">
      {{ row.totalItem }}
    </b-td>
    <!-- Total Order -->
    <b-td class="!py-[12px]">
      {{ row.totalOrder }}
    </b-td>
    <!-- Status -->
    <b-td
      v-if="row.isFirstProduct"
      :rowspan="row.rowspan"
      class="!py-[12px]"
    >
      <StatusPackingPill :status="row.status" />
    </b-td>
    <!-- Packings -->
    <b-td
      v-if="row.isFirstProduct"
      :rowspan="row.rowspan"
      class="!py-[12px]"
    >
      <PackingsCell :items="row.packings" />
    </b-td>
  </BTr>
</template>

<script>
import StatusPackingPill from '../../components/StatusPackingPill.vue'
import PackingsCell from './PackingsCell.vue'

export default {
  name: 'TableRow',
  components: {
    StatusPackingPill,
    PackingsCell,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: false,
      count: 0,
    }
  },
  methods: {
    /**
     * Sets the selected state for the row.
     * @public Exposed for parent access via $refs
     * @param {boolean} value - The new selected state
     */
    forceUpdateCheckbox(value) {
      if (this.selected === value) {
        return
      }
      this.selected = value
      this.emitToggleSelect()
    },
    emitToggleSelect() {
      this.$emit('toggle-select', this.row.orderIndex)
    },
  },
}
</script>
